import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputAdornment,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Divider,
  TextareaAutosize,
  InputLabel,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";

import React from "react";
import { styled } from "@mui/material/styles";
import { Add, CancelOutlined, CloudUpload, Remove } from "@mui/icons-material";
import { useState, useEffect, useRef } from "react";
import upload from "../../assets/Project_Images/Icons/upload.png";
import gallery from "../../assets/Project_Images/Icons/gallery.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  ApiGetClientDbName,
  ApiGetClientEntities,
  ApiGetClients,
  ApiGetVenueList,
  ApiuploadDocuments,
} from "../../apiService/Core/Apicall.tsx";
import { ApisendApplication } from "../../apiService/Core/Apicall.tsx";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../Redux/loadingSlice.tsx";
import Loading from "../Loader/Loading.tsx";
import { toast } from "react-toastify";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  borderWidth: "5px",
  width: 22,
  height: 22,
  borderColor: "green",
  boxShadow:
    "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  // backgroundColor: '#f5f8fa',
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto #ADB792",
    outlineOffset: 2,
  },
}));
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#ADB792",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,100%,0%,.1),hsla(0,100%,0%,0))",
  "&::before": {
    display: "block",
    width: 22,
    height: 22,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
});

// Inspired by blueprintjs
function BpRadio(props: any) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

interface FormValues {
  firstname: string;
  lastname: string;
  email: string;
  contactNo: string;
  address: string;
  dob: Dayjs;
  gender: string;
  profile_pic: string;
  driving_licence: string;
  latitude: string;
  longitude: string;
  workForAldi: boolean | string;
  workForBlooms: boolean | string;
  workForHotelpub: boolean | string;
  buyAlcohol: boolean | string;
  hotelPubName: string;
  shoppperDetail: string;
  isShopperCanVisitSmokingArea: boolean | string;
  isShopperCanDoGambling: boolean | string;
  isShopperRelativeWorkForYochi: boolean | string;
  isShopperRelativeWorkForJbHifi: boolean | string;
  country: string,
  countryCode: string,
  state: string,
  city: string,
  postalCode: Number | null,
}

interface VenueSelection {
  clientId: string;
  selectedClientId: string;
  clientEntityId: string;
  venueId: string;
  clientsList: any[];
  clientEntityList: any[];
  venueList: any[];
}

function Applicationform() {
  const dispatch = useDispatch();
  const loading = useSelector((state: any) => state.loader.isLoading);

  const navigate = useNavigate();
  const autocompleteRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDialog, setDialog] = useState<boolean>(false);
  const [showerror, setshowerror] = useState<boolean>(false);
  const [venueSelections, setVenueSelections] = useState<VenueSelection[]>([
    {
      clientId: "",
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    },
  ]);
  const [allSelectedVenueIds, setAllSelectedVenueIds] = useState<string>("");
  const [Clientlist, setClientlist] = useState<any[]>([]);
  const [fulladdress, setfulladdress] = useState<any>()
  const [streetNumber, setstreetNumber] = useState<any>()
  const [route, setroute] = useState<any>()

  const emailId = localStorage.getItem("emailId");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const initialValues: FormValues = {
    firstname: "",
    lastname: "",
    email: emailId ? emailId : userData?.emailId,
    contactNo: "",
    address: "",
    dob: null as Dayjs | null,
    gender: "",
    profile_pic: "",
    driving_licence: "",
    latitude: "",
    longitude: "",
    workForAldi: "",
    workForBlooms: "",
    workForHotelpub: "",
    buyAlcohol: "",
    shoppperDetail: "",
    hotelPubName: "",
    isShopperCanVisitSmokingArea: "",
    isShopperCanDoGambling: "",
    isShopperRelativeWorkForJbHifi: "",
    isShopperRelativeWorkForYochi: "",
    country: "",
    countryCode: '+61',
    state: "",
    city: "",
    postalCode: null
  };

  const keyup = (e: any) => {
    if (e.code === "Enter") {
      formik.handleSubmit();
    }
  };
  const validationSchema = Yup.object({
    firstname: Yup.string().required("firstname is required"),
    lastname: Yup.string().required("lastname is required"),
    contactNo: Yup.string().required("contactNo is required"),
    profile_pic: Yup.string().required("profile image is required"),
    driving_licence: Yup.string().required("driving licence is required"),
    address: Yup.string().required("address is required"),
    dob: Yup.string().required("dob is required"),
    gender: Yup.string().required("gender is required"),
    workForAldi: Yup.string().required("This field is required"),
    workForBlooms: Yup.string().required("This field is required"),
    workForHotelpub: Yup.string().required("This field is required"),
    buyAlcohol: Yup.string().required("This field is required"),
    shoppperDetail: Yup.string()
      .test(
        "min-words",
        "Minimum 150 words required",
        (value) =>
          (value?.trim().split(/\s+/).filter(Boolean).length ?? 0) >= 150
      )
      .test(
        "max-words",
        "Maximum 500 words allowed",
        (value) =>
          (value?.trim().split(/\s+/).filter(Boolean).length ?? 0) <= 500
      )
      .required("shopperDetail is required"),
    isShopperCanVisitSmokingArea: Yup.string().required(
      "This field is required"
    ),
    isShopperCanDoGambling: Yup.string().required("This field is required"),
    isShopperRelativeWorkForYochi: Yup.string().required("This field is required"),
    isShopperRelativeWorkForJbHifi: Yup.string().required("This field is required"),
  });

  const formStyles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#fff",
    },
    section: {
      marginBottom: "30px",
      borderBottom: "1px solid #f0f0f0",
      paddingBottom: "20px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
    },
    sectionNumber: {
      marginRight: "8px",
    },
    sectionDescription: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "15px",
    },
    formRow: {
      display: "flex",
      flexWrap: "wrap",
      margin: "0 -10px",
      marginBottom: "15px",
    },
    formColumn: {
      flex: "1 0 calc(50% - 20px)",
      margin: "0 10px",
      minWidth: "250px",
    },
    formColumnFull: {
      flex: "1 0 calc(100% - 20px)",
      margin: "0 10px",
    },
    formColumnThird: {
      flex: "1 0 calc(33.333% - 20px)",
      margin: "0 10px",
      minWidth: "200px",
    },
    formColumnQuarter: {
      flex: "1 0 calc(25% - 20px)",
      margin: "0 10px",
      minWidth: "180px",
    },
    inputLabel: {
      display: "block",
      fontSize: "14px",
      marginBottom: "5px",
      color: "#333",
    },
    requiredStar: {
      color: "red",
      marginLeft: "2px",
    },
    textField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    radioGroup: {
      display: "flex",
      alignItems: "center",
      marginTop: "5px",
    },
    radioLabel: {
      marginRight: "20px",
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    },
    radioInput: {
      marginRight: "5px",
      width: "16px",
      height: "16px",
      accentColor: "#1976d2",
      cursor: "pointer",
    },
    uploadBox: {
      border: "1px dashed #ccc",
      borderRadius: "4px",
      height: "200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      width: "50%",
      position: "relative" as const,
    },
    uploadIcon: {
      fontSize: "24px",
      color: "#666",
      marginBottom: "8px",
    },
    uploadText: {
      fontSize: "14px",
      color: "#666",
    },
    textareaField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      minHeight: "100px",
      boxSizing: "border-box",
      resize: "vertical",
    },
    wordCount: {
      fontSize: "12px",
      color: "#666",
      textAlign: "right",
      marginTop: "5px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#1976d2",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "bold",
    },
    otherDetailsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      marginBottom: "20px",
    },
    otherDetailsItem: {
      flex: "1 0 200px",
      minWidth: "200px",
    },
    questionContainer: {
      marginBottom: "10px",
    },
    fileInput: {
      position: "absolute" as const,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
    },
    // Clean dropdown styles matching the image design
    dropdownContainer: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginBottom: "15px",
      flexWrap: "wrap",
    },
    dropdown: {
      width: "200px",
      height: "45px",
      padding: "0 15px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      color: "#6b7280",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: "right 12px center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "16px",
      transition: "border-color 0.15s ease-in-out",
    },
    dropdownFocus: {
      borderColor: "#3b82f6",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
    },
    iconButton: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      transition: "all 0.2s ease",
    },
    addButton: {
      backgroundColor: "#10b981",
      color: "white",
      "&:hover": {
        backgroundColor: "#059669",
      },
    },
    removeButton: {
      backgroundColor: "#ef4444",
      color: "white",
      "&:hover": {
        backgroundColor: "#dc2626",
      },
    },
  };

  const onSubmit = async (values: FormValues) => {
    const userId = userData.userId || 0;

    const apiData = {
      userId,
      firstName: values.firstname,
      driving_licence: values.driving_licence,
      lastName: values.lastname,
      contactNo: values.contactNo.startsWith(values.countryCode) ? values.contactNo.slice(values.countryCode.length) : values.contactNo,
      isFirstTimeUpdate: true,
      address: values.address,
      dob: values.dob,
      gender: values.gender,
      profilePicUrl: values.profile_pic,
      latitude: Number(values.latitude) || 0,
      longitude: Number(values.longitude) || 0,
      workForAldi: values.workForAldi === "true",
      workForBlooms: values.workForBlooms === "true",
      workForHotelpub: values.workForHotelpub === "true",
      isShopperBuyAlcohol: values.buyAlcohol === "true",
      hotelPubName: values.workForHotelpub === "true" ? values.hotelPubName : null, // Send null if No
      shoppperDetail: values.shoppperDetail,
      isShopperCanVisitSmokingArea:
        values.isShopperCanVisitSmokingArea === "true",
      isShopperCanDoGambling: values.isShopperCanDoGambling === "true",
      isShopperRelativeWorkForJbHifi: values.isShopperRelativeWorkForJbHifi === 'true',
      isShopperRelativeWorkForYochi: values.isShopperRelativeWorkForYochi === 'true',
      relativeVenueIds: allSelectedVenueIds,
      country: values.country,
      countryCode: values.countryCode,
      state: values.state,
      city: values.city,
      postalCode: values.postalCode
    };

    try {
      if (!streetNumber || !route) {
        formik.setFieldError('address', 'Please select a valid address');
        return;
      }
      const response = await ApisendApplication(apiData);
      if (response.status) {
        // console.log("API Response:", response);
        toast.success(response.message);
        // setDialog(true);
        localStorage.setItem('FirstName', values.firstname)
        navigate('/agreement')
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
      toast.error("Something went wrong. Please try again.");
    }
  };

  const formik = useFormik<FormValues>({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: false,
  });
  useEffect(() => {
    const loadAutocomplete = async () => {
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      if (!inputRef.current) {
        console.error("Input reference is null.");
        return;
      }

      try {
        autocompleteRef.current = new window.google.maps.places.Autocomplete(
          inputRef.current as HTMLInputElement,
          {
            types: ["geocode"],
            componentRestrictions: { country: "AU" },
          }
        );

        autocompleteRef.current.addListener("place_changed", async () => {
          const place = await autocompleteRef.current.getPlace();
          // console.log("Autocomplete place object:", place);

          if (!place || !place.formatted_address) {
            console.warn("No address found.");
            return;
          }
          setfulladdress(place.formatted_address)
          formik.setFieldValue("address", place.formatted_address);

          if (place.geometry?.location) {
            formik.setFieldValue("latitude", place.geometry.location.lat());
            formik.setFieldValue("longitude", place.geometry.location.lng());
          }
          let streetNumber = ''
          let route = ''
          let subpremise = ''
          place?.address_components?.forEach((component: any) => {
            const types = component.types;
            if (types.includes("country")) {
              formik.setFieldValue("country", component.short_name); // e.g. "Australia"
              // formik.setFieldValue("countryCode", component.short_name);// e.g. "AU"
            }
            if (types.includes("street_number")) {
              streetNumber = component.long_name; // e.g. "221B"
            }

            if (types.includes("route")) {
              route = component.long_name; // e.g. "Baker Street"
            }
            if (types.includes("subpremise")) {
              subpremise = component.long_name; // e.g. "Baker Street"
            }
            if (types.includes("administrative_area_level_1")) {
              formik.setFieldValue("state", component.short_name); // e.g. "New South Wales"
            }
            if (types.includes("locality")) {
              formik.setFieldValue("city", component.long_name); // e.g. "Sydney"
            }
            if (types.includes("postal_code")) {
              formik.setFieldValue("postalCode", component.long_name); // e.g. "2000"
            }
            formik.setFieldValue('address', subpremise + " " + streetNumber + " " + route)
            setroute(route)
            setstreetNumber(streetNumber)
          });
        });
      } catch (error) {
        console.error("Error initializing autocomplete:", error);
      }
    };

    loadAutocomplete();
    handleCallGetClientDbName();
  }, []);
  console.log("Formik Values", formik.values)

  const handleCallGetClientDbName = async () => {
    try {
      {
        const response = await ApiGetClientDbName();
        setClientlist(response.data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      // toast.error(`${error}`);
    }
  };

  const addVenueSelection = () => {
    setVenueSelections([
      ...venueSelections,
      {
        clientId: "",
        selectedClientId: "",
        clientEntityId: "",
        venueId: "",
        clientsList: [],
        clientEntityList: [],
        venueList: [],
      },
    ]);
  };

  const removeVenueSelection = (index: number) => {
    if (venueSelections.length > 1) {
      const updatedSelections = [...venueSelections];
      updatedSelections.splice(index, 1);
      setVenueSelections(updatedSelections);
    }
  };

  const handleClientDbChange = async (index: number, clientId: string) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientId,
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    };

    if (clientId) {
      try {
        const data = `?clientGroup=${clientId}&status=active&offset=0&limit=100`;
        // Replace with your actual API call
        const response: any = await ApiGetClients(data);
        updatedSelections[index].clientsList = response.data || [];
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };

  const handleClientChange = async (
    index: number,
    selectedClientId: string
  ) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      selectedClientId,
      clientEntityId: "",
      venueId: "",
      clientEntityList: [],
      venueList: [],
    };

    if (selectedClientId) {
      try {
        const data = `?clientId=${selectedClientId}&offset=0&limit=100`;
        // Replace with your actual API call
        const response: any = await ApiGetClientEntities(data);
        updatedSelections[index].clientEntityList = response.data || [];
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };

  const handleBusinessChange = async (
    index: number,
    clientEntityId: string
  ) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientEntityId,
      venueId: "",
      venueList: [],
    };

    if (clientEntityId) {
      try {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`;
        // Replace with your actual API call
        const res = await ApiGetVenueList(data);
        const venueOptions =
          res?.data?.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
          })) || [];
        updatedSelections[index].venueList = venueOptions;
      } catch (error) {
        console.error("Error fetching venues:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };

  const handleVenueChange = (index: number, venueId: string) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index].venueId = venueId;
    setVenueSelections(updatedSelections);

    const selectedVenueIds = updatedSelections
      .map((selection) => selection.venueId)
      .filter((id) => id);

    setAllSelectedVenueIds(selectedVenueIds.join(","));
  };

  const fileupload = async (filePath: any, fileType: any) => {
    const userId: any = localStorage.getItem("userId");
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("fileType", fileType);
    formData.append("file", filePath); // Add a file
    try {
      const response: any = await ApiuploadDocuments(formData);
      if (response.status) {
        // console.log(response)
        formik.setFieldValue(fileType, response.location);
      }
    } catch (error) {
      // console.log(error)
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const imageUrl = URL.createObjectURL(file);
      fileupload(file, "profile_pic");
    } else {
      toast.error("Please upload a valid image file.");
    }
  };
  const handleFileChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file2 = event.target.files?.[0];
    if (file2 && file2.type.startsWith("image/") || file2 && file2.type == "application/pdf") {
      fileupload(file2, "driving_licence");
      const imageUrl2 = URL.createObjectURL(file2);
      // formik.setFieldValue("driving_licence", imageUrl2);
    } else {
      toast.error("Please upload a valid image file.");
    }
  };

  const isPDF = (url: string) => {
    return url?.toLowerCase().endsWith(".pdf");
  };
  return (
    <>
      <Box height="100vh">
        <form onSubmit={formik.handleSubmit}>
          {/* ------------------------------------------------------------------------------ Header ---------------------------------------------------------- */}
          <Box
            padding="20px"
            className="w-100 custom-bg d-flex align-items-center justify-content-between"
            height="72px"
          >
            <Typography className="text-white fs-4 p-0 m-0">
              Application Form
            </Typography>
            <CancelOutlined className="fs-4 text-white" />
          </Box>
          {/* ------------------------------------------------------------------------------------ Part-1---------------------------------------------- */}
          <Box padding="20px">
            <Typography className="form-heading">
              1. Personal Details
            </Typography>
            <Typography className="form-caption">
              Tell us a little about yourself.
            </Typography>
            <Box className="mt-2 d-flex flex-column flex-md-row gap-3">
              <Box className="w-md-75 w-100">
                <FormControl className="w-49 me-2">
                  <TextField
                    label={
                      <span>
                        First Name{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: false,
                    }}
                    variant="outlined"
                    placeholder="Enter your first name"
                    {...formik.getFieldProps("firstname")}
                  ></TextField>
                  {showerror && formik.errors.firstname ? (
                    <Typography className="error ">
                      {formik.errors.firstname}
                    </Typography>
                  ) : null}
                </FormControl>
                <FormControl className="w-49">
                  <TextField
                    label={
                      <span>
                        Last Name{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: false,
                    }}
                    placeholder="Enter your last name"
                    {...formik.getFieldProps("lastname")}
                  ></TextField>
                  {showerror && formik.errors.lastname ? (
                    <Typography className="error ">
                      {formik.errors.lastname}
                    </Typography>
                  ) : null}
                </FormControl>
                <FormControl className="w-49 me-2">
                  <TextField
                    label={
                      <span>
                        Email{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    disabled
                    InputLabelProps={{
                      shrink: false,
                    }}
                    {...formik.getFieldProps("email")}
                  ></TextField>
                  {showerror && formik.errors.email ? (
                    <Typography className="error ">
                      {formik.errors.email}
                    </Typography>
                  ) : null}
                </FormControl>
                <FormControl className="w-49">
                  <TextField
                    type="number"
                    placeholder="Enter your mobile number"
                    label={
                      <span>
                        Mobile{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="h-100">
                          <Typography className="fw-bold">+61</Typography>
                        </InputAdornment>
                      ),
                    }}
                    InputLabelProps={{
                      shrink: false,
                    }}
                    inputProps={{
                      maxLength: 10,
                      pattern: "[0-9]*",
                    }}
                    value={formik.values.contactNo}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        formik.setFieldValue("contactNo", value);
                      }
                    }}
                  ></TextField>
                  {/* <div className="mt-3">
                    <label style={{ fontSize: "14px", color: "#0000008A" }} htmlFor="">
                      <span>
                        Mobile{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    </label>
                    <PhoneInput
                      country={"au"}
                      value={
                        formik.values.countryCode && formik.values.contactNo
                          ? formik.values.countryCode + formik.values.contactNo
                          : formik.values.contactNo
                      } onChange={(phone, country: any) => {

                        formik.setFieldValue("contactNo", phone);
                        formik.setFieldValue("countryCode", country.dialCode);
                      }} inputProps={{
                        name: "contactNo",
                        required: true,
                        autoFocus: false,
                      }}
                    />
                    {showerror && formik.errors.contactNo ? (
                      <p className="error">{formik.errors.contactNo}</p>
                    ) : null}
                  </div> */}
                  {showerror && formik.errors.contactNo ? (
                    <Typography className="error ">
                      {formik.errors.contactNo}
                    </Typography>
                  ) : null}
                </FormControl>
                <FormControl className="w-100 me-2" sx={{ maxWidth: '81%' }}>
                  <TextField
                    placeholder="Enter your address"
                    inputRef={inputRef}
                    value={fulladdress}
                    onChange={(e) =>
                      setfulladdress(e.target.value)
                    }
                    label={
                      <span>
                        Address{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: false,
                    }}
                  // {...formik.getFieldProps("address")}
                  ></TextField>
                  {showerror && formik.errors.address ? (
                    <Typography className="error ">
                      {formik.errors.address}
                    </Typography>
                  ) : null}
                  <Typography variant="subtitle2" className="text-secondary"><b>Note:</b> Start typing your address and select it from the suggestions.</Typography>
                </FormControl>
                <FormControl className="w-49 me-5">
                  {/* <TextField
                                    label={
                                        <span>
                                            D.O.B{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }
                                    sx={{


                                    }}

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    {...formik.getFieldProps("dob")}

                                    
                                ></TextField> */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        label={
                          <span>
                            D.O.B{" "}
                            <sup>
                              <i className="fa-solid fa-star-of-life star"></i>
                            </sup>
                          </span>
                        }
                        maxDate={dayjs().subtract(14, "year")}
                        minDate={dayjs().subtract(90, "year")}
                        value={
                          formik.values.dob ? dayjs(formik.values.dob) : null
                        } // Ensure it's a dayjs object
                        onChange={(newValue) =>
                          formik.setFieldValue("dob", dayjs(newValue).format("YYYY-MM-DD"))
                        }
                        renderInput={(params: any) => <TextField {...params} />}
                        slotProps={{
                          textField: {
                            InputLabelProps: { shrink: false }, // Prevents label from shrinking
                          },
                        }}
                        placeholder="Select your date of birth"
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  {showerror && formik.errors.dob ? (
                    <Typography className="error ">
                      {formik.errors.dob}
                    </Typography>
                  ) : null}
                </FormControl>
                <FormControl className="mt-3">
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Gender{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    // name="row-radio-buttons-group"

                    {...formik.getFieldProps("gender")}
                  >
                    <FormControlLabel
                      value="Male"
                      control={<BpRadio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="Female"
                      control={<BpRadio />}
                      label="Female"
                    />
                  </RadioGroup>
                  {showerror && formik.errors.gender ? (
                    <Typography className="error ">
                      {formik.errors.gender}
                    </Typography>
                  ) : null}
                </FormControl>
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  borderColor: "#00000033",
                  border: "1px solid #00000033",
                  height: "auto",
                }}
              />
              <Box className="w-md-25 w-100 d-flex align-items-center justify-content-md-start">
                <Box width={{ xs: "100%", md: "20%" }}>
                  <FormControl className="w-100">
                    {!formik.values.profile_pic && (
                      <label htmlFor="file-upload" className="form-caption">
                        <span>
                          Profile Image{" "}
                          <sup>
                            <i className="fa-solid fa-star-of-life star"></i>
                          </sup>
                        </span>

                        <Box
                          className="mt-2 d-flex align-items-center justify-content-center"
                          height={300}
                          width={{ xs: "100%", md: "300px !important" }}
                          border="1px dashed #00000033"
                          borderRadius={5}
                        >
                          <input
                            type="file"
                            id="file-upload"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <Box className="d-flex flex-column align-items-center justify-content-center">
                            <Box
                              component="img"
                              height={36}
                              width={36}
                              src={upload}
                            ></Box>
                            <Typography className="form-caption">
                              Upload Here
                            </Typography>
                          </Box>
                        </Box>
                      </label>
                    )}

                    {formik.values.profile_pic && (
                      <label htmlFor="file-upload" className="form-caption">
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          height={300}
                          width={{ xs: "100%", md: "300px !important" }}
                          border="1px dashed #00000033"
                          borderRadius={5}
                        >
                          <img
                            src={formik.values.profile_pic}
                            alt="Uploaded preview"
                            width="100%"
                            height="100%"
                            style={{ borderRadius: "8px" }}
                          />
                          <input
                            type="file"
                            id="file-upload"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </Box>
                      </label>
                    )}
                    {showerror && formik.errors.profile_pic ? (
                      <Typography className="error ">
                        {formik.errors.profile_pic}
                      </Typography>
                    ) : null}
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Box>
          <Divider
            orientation="horizontal"
            sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
          />

          {/* ------------------------------------------------------------------------------------ Part-2---------------------------------------------- */}
          <Box padding="20px">
            <Typography className="form-heading">2. Other Details</Typography>
            <Typography className="form-caption">
              {" "}
              these details help us match you to the right tasks{" "}
            </Typography>
            <Box>
              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Do you or an immediate family member or close friend work for
                  ALDI?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("workForAldi")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.workForAldi ? (
                  <Typography className="error ">
                    {formik.errors.workForAldi}
                  </Typography>
                ) : null}
              </FormControl>
              <FormControl className="mt-3 col-md-4 col-12">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Do you or an immediate family member or close friend work for
                  Blooms the Chemist?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("workForBlooms")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="No"
                  />
                </RadioGroup>
                {showerror && formik.errors.workForBlooms ? (
                  <Typography className="error ">
                    {formik.errors.workForBlooms}
                  </Typography>
                ) : null}
              </FormControl>
              <FormControl className="mt-3 col-md-4 col-12">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Do you or an immediate family member or close friend work for
                  a hotel/pub chain?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  // row
                  // aria-labelledby="hotel-pub-radio-label"
                  // name="workForHotelpub"
                  // value={formik.values.workForHotelpub}
                  // onChange={(e) => {
                  //   const value = e.target.value === "true";
                  //   formik.setFieldValue("workForHotelpub", value);
                  //   if (!value) {
                  //     formik.setFieldValue("hotelPubName", "");
                  //   }
                  // }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("workForHotelpub")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="No"
                  />
                </RadioGroup>
                {showerror && formik.errors.workForHotelpub ? (
                  <Typography className="error ">
                    {formik.errors.workForHotelpub}
                  </Typography>
                ) : null}
              </FormControl>

              {formik.values.workForHotelpub === "true" && (
                <FormControl className="col-md-4 col-12">
                  <TextField
                    placeholder="Enter the name of the hotel/pub"
                    label={
                      <span>
                        Hotel/Pub Name{" "}
                        <sup>
                          <i className="fa-solid fa-star-of-life star"></i>
                        </sup>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: false,
                    }}
                    {...formik.getFieldProps("hotelPubName")}
                  />
                  {showerror && formik.errors.hotelPubName ? (
                    <Typography className="error ">
                      {formik.errors.hotelPubName}
                    </Typography>
                  ) : null}
                </FormControl>
              )}
            </Box>
            <Box>
              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Are you prepared to buy alcohol?*{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("buyAlcohol")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.buyAlcohol ? (
                  <Typography className="error ">
                    {formik.errors.buyAlcohol}
                  </Typography>
                ) : null}
              </FormControl>

              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Are you prepared to go to the smoking area?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("isShopperCanVisitSmokingArea")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.isShopperCanVisitSmokingArea ? (
                  <Typography className="error ">
                    {formik.errors.isShopperCanVisitSmokingArea}
                  </Typography>
                ) : null}
              </FormControl>
              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Are you prepared to gamble?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("isShopperCanDoGambling")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.isShopperCanDoGambling ? (
                  <Typography className="error ">
                    {formik.errors.isShopperCanDoGambling}
                  </Typography>
                ) : null}
              </FormControl>
              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Do you or an immediate family member or close friend work for Yo-Chi?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("isShopperRelativeWorkForYochi")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.isShopperRelativeWorkForYochi ? (
                  <Typography className="error ">
                    {formik.errors.isShopperRelativeWorkForYochi}
                  </Typography>
                ) : null}
              </FormControl>
              <FormControl className="col-md-4 col-12 mt-3">
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Do you or an immediate family member or close friend work for JB Hi-Fi or Good Guys?{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  // name="row-radio-buttons-group"
                  {...formik.getFieldProps("isShopperRelativeWorkForJbHifi")}
                >
                  <FormControlLabel
                    value="true"
                    control={<BpRadio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<BpRadio />}
                    label="NO"
                  />
                </RadioGroup>
                {showerror && formik.errors.isShopperRelativeWorkForJbHifi ? (
                  <Typography className="error ">
                    {formik.errors.isShopperRelativeWorkForJbHifi}
                  </Typography>
                ) : null}
              </FormControl>
            </Box>
          </Box>
          <Divider
            orientation="horizontal"
            sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
          />

          {/* ---------------------------------------------------------------------------------Part-3 -------------------------------------------------------------- */}
          <Box padding="20px">
            <Typography className="form-heading">
              3. Document Details
            </Typography>
            <Typography className="form-caption">
              Upload documents for verification.
            </Typography>
            <Box
              width={{ xs: "100%", md: "20%" }}
              className="mt-2 d-flex align-items-center"
            >
              <FormControl className="w-100">
                {!formik.values.driving_licence && (
                  <label htmlFor="file-upload2" className="form-caption ">
                    <span>
                      Add your Driver's License or Photo ID here{" "}
                      <sup>
                        <i className="fa-solid fa-star-of-life star"></i>
                      </sup>
                    </span>

                    <Box
                      className="mt-2 d-flex align-items-center justify-content-center "
                      height={180}
                      width={{ xs: "100%", md: "300px !important" }}
                      border="1px dashed #00000033"
                      borderRadius={5}
                    >
                      <input
                        type="file"
                        id="file-upload2"
                        accept="image/*,.pdf"
                        style={{ display: "none" }}
                        onChange={handleFileChange2}
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box
                          component="img"
                          height={36}
                          width={36}
                          src={gallery}
                        ></Box>
                        <Typography className="form-caption">
                          Capture/Upload Here
                        </Typography>
                      </Box>
                    </Box>
                  </label>
                )}

                {/* {formik.values.driving_licence && (
                  <label htmlFor="file-upload2" className="form-caption">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      height={180}
                      width={{ xs: "100%", md: "300px !important" }}
                      border="1px dashed #00000033"
                      borderRadius={5}
                    >
                      <img
                        src={formik.values.driving_licence}
                        alt="Uploaded preview"
                        width="100%"
                        height="100%"
                        style={{ borderRadius: "8px" }}
                      />
                      <input
                        type="file"
                        id="file-upload2"
                        accept="image/*,.pdf"
                        style={{ display: "none" }}
                        onChange={handleFileChange2}
                      />
                    </Box>
                  </label>
                )} */}
                {formik.values.driving_licence && (
                  <>
                    <Box className='d-flex justify-content-end'>
                      <IconButton onClick={() => { formik.setFieldValue('driving_licence', null) }}><CancelOutlined /></IconButton>
                    </Box>
                    {isPDF(formik.values.driving_licence) ? (
                      <iframe
                        src={`${formik.values.driving_licence}#toolbar=0`}
                        title="PDF Preview"
                        width="100%"
                        height="400px"
                        style={{ border: "none", borderRadius: "8px" }}
                      />
                    ) : (
                      <img
                        src={formik.values.driving_licence}
                        alt="Uploaded preview"
                        width="100%"
                        height="100%"
                        style={{ objectFit: "cover", border: '2px dashed #ccc', borderRadius: "8px" }}
                      />
                    )}
                  </>
                )}
                {showerror && formik.errors.driving_licence ? (
                  <Typography className="error ">
                    {formik.errors.driving_licence}
                  </Typography>
                ) : null}
              </FormControl>
            </Box>
          </Box>
          <Divider
            orientation="horizontal"
            sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
          />

          {/* <Box padding="20px">
            <Typography className="form-heading">3. Venue Selection</Typography>
            <Typography className="form-caption">
              Select the venues you want to work with.
            </Typography>

            <Box className="mt-3">
              <FormControl className="w-100">
                <FormLabel className="form-caption mb-2">
                  Select Venues <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </FormControl>
            </Box>
          </Box>
          <Divider
            orientation="horizontal"
            sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
          /> */}
          {/* ---------------------------------------------------------------------------------Part-3 -------------------------------------------------------------- */}
          <Box padding="20px">
            <Typography className="form-heading">
              4. Shopper Application
            </Typography>
            <Typography className="form-caption">
              {/* Final step! Submit your application */}
            </Typography>
            <FormControl className="w-100 mt-2">
              <label htmlFor="textarea-label" className="form-caption">
                <span>
                  Please write a fact-based review (minimum 150 words) about a recent customer
                  service experience you have had at a store, restaurant or
                  hotel.{" "}
                  <sup>
                    <i className="fa-solid fa-star-of-life star"></i>
                  </sup>
                </span>
              </label>
              <textarea
                id="textarea-label"
                className="custom-textarea"
                placeholder="Enter your review here"
                rows={4}
                value={formik.values.shoppperDetail}
                onChange={(e) => {
                  const text = e.target.value;
                  const wordCount = text
                    .trim()
                    .split(/\s+/)
                    .filter(Boolean).length;
                  if (wordCount <= 500) {
                    formik.setFieldValue("shoppperDetail", text);
                  }
                }}
              />
              <Typography
                className="letter-count bg-light text-secondary"
                variant="caption"
                position="absolute"
                bottom={2}
                right={10}
              >
                Words:{" "}
                {
                  formik.values.shoppperDetail
                    .trim()
                    .split(/\s+/)
                    .filter(Boolean).length
                }
              </Typography>
              {showerror && formik.errors.shoppperDetail ? (
                <Typography className="error ">
                  {formik.errors.shoppperDetail}
                </Typography>
              ) : null}
            </FormControl>
          </Box>
          <Divider
            className="mb-3"
            orientation="horizontal"
            sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
          />

          <Box className="w-100 d-flex justify-content-end p-2 pe-3">
            <Button
              type="submit"
              onClick={() => {
                setshowerror(true);
              }}
              className="button-primary w-30 py-2 px-70"
            >
              Submit
            </Button>
          </Box>
        </form>
        {loading && <Loading />}
      </Box>

      {(localStorage.getItem('isPopup') == 'true' ||
        (userData.isShopperStep1DocumentSubmitted &&
          userData.userStatus.userStatus !== "approve")) && (
          <Dialog
            open={false}
            BackdropProps={{ style: { backdropFilter: "blur(5px)" } }}
          >
            <DialogContent className="w-100 p-4">
              <Box className="w-100 d-flex justify-content-end">
                <IconButton
                  onClick={() => {
                    localStorage.clear();
                    navigate("/login");
                  }}
                >
                  <CancelOutlined sx={{ height: "36px", width: "36px" }} />
                </IconButton>
              </Box>

              {/* SVG Box */}
              <Box className="text-center">
                <svg
                  width="150"
                  height="150"
                  viewBox="0 0 150 150"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_437_2398)">
                    <path
                      d="M109.375 0H40.6255C35.4479 0 31.2505 4.19736 31.2505 9.375C31.2505 14.5526 35.4479 18.75 40.6255 18.75H109.376C114.553 18.75 118.751 14.5526 118.751 9.375C118.751 4.19736 114.553 0 109.375 0Z"
                      fill="#ADB792"
                    />
                    <path
                      d="M109.375 137.5H40.6253C38.8995 137.5 37.5002 136.101 37.5002 134.375V108.219C37.5 100.107 41.0015 92.3907 47.1064 87.0498L58.1876 77.3499C59.4855 76.2123 59.6153 74.238 58.4777 72.9402C58.3875 72.8373 58.2905 72.7404 58.1876 72.6501L47.1064 62.9502C41.0015 57.6094 37.5 49.8929 37.5002 41.7815V15.6252C37.5002 13.8993 38.8995 12.5001 40.6253 12.5001H109.375C111.101 12.5001 112.501 13.8993 112.501 15.6252V41.7815C112.501 49.8929 108.999 57.6094 102.894 62.9502L91.8131 72.6501C90.5153 73.7877 90.3855 75.762 91.5231 77.0599C91.6133 77.1627 91.7103 77.2597 91.8131 77.3499L102.894 87.0498C108.999 92.3907 112.501 100.107 112.501 108.219V134.375C112.5 136.101 111.101 137.5 109.375 137.5Z"
                      fill="#ADB792"
                    />
                    <path
                      d="M43.7498 131.25H106.25V108.219C106.242 101.906 103.508 95.9045 98.7497 91.7563L87.6684 82.0564C83.7713 78.6475 83.3758 72.7248 86.7848 68.8277C87.0593 68.514 87.3546 68.2187 87.6684 67.9441L98.7497 58.2442C103.508 54.0961 106.242 48.0943 106.25 41.7817V18.75H43.7498V41.7812C43.7574 48.0938 46.4917 54.0955 51.2498 58.2436L62.331 67.9436C66.2263 71.3546 66.6189 77.2775 63.2082 81.1729C62.9354 81.4843 62.6424 81.7772 62.331 82.05L51.2498 91.7563C46.4917 95.9045 43.7574 101.906 43.7498 108.219V131.25Z"
                      fill="white"
                    />
                    <path
                      d="M93.5121 51.9314C93.029 50.7627 91.8894 50.0004 90.6246 50.0001H59.3748C57.6489 49.9969 56.2474 51.3938 56.2441 53.1197C56.2427 53.9517 56.5732 54.75 57.1623 55.3377L72.7872 70.9626C74.0074 72.1825 75.9856 72.1825 77.2061 70.9626L92.831 55.3377C93.7263 54.4445 93.9952 53.1 93.5121 51.9314Z"
                      fill="black"
                      fillOpacity="0.2"
                    />
                    <path
                      d="M109.375 131.25H40.6252C35.4476 131.25 31.2502 135.447 31.2502 140.625C31.2502 145.803 35.4476 150 40.6252 150H109.375C114.553 150 118.75 145.803 118.75 140.625C118.75 135.447 114.553 131.25 109.375 131.25Z"
                      fill="#ADB792"
                    />
                    <path
                      d="M77.0999 97.6875C75.8653 96.5698 73.9715 96.6167 72.7935 97.7938L43.7498 126.831V131.25H106.25V124.187L77.0999 97.6875Z"
                      fill="black"
                      fillOpacity="0.2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_437_2398">
                      <rect width="150" height="150" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Box>

              {/* Application Status */}
              <Box className="text-center mt-4 form-heading">
                {userData.userStatus.userStatus === 'reject' ? 'Application Rejected !' : 'Application Under Review!'}
              </Box>

              {/* Thank You Message */}
              {userData.userStatus.userStatus !== 'reject' ? (

                <Box className="text-center mt-4 w-75 mx-auto">
                  Please be patient while we review your application. We will get back to you within 28 days.
                </Box>
              ) :
                (
                  <Box className="text-center mt-4 w-75 mx-auto">
                    Unfortunitely your application has been rejected
                  </Box>
                )
              }

              {/* Logout Button */}

              <Box className="d-flex justify-content-center mt-4">
                <Button
                  className="button-primary px-70 py-2"
                  onClick={() => {
                    localStorage.clear();
                    navigate("/login");
                  }}
                >

                  Logout
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        )}

    </>
  );
}

export default Applicationform;
